// Normalises a backend datetime (Motor sometimes strips the tz suffix, so a
// bare ISO like "2026-05-27T09:15:09.657000" is treated as UTC) and formats it
// for "last edited" displays across the Courses / AI Labs / Industry Labs grids.
// Uses the shared parseIsoAsUtc parser (utils/dateFormat) so UTC normalisation
// lives in one place; keeps the null-on-invalid contract this module relies on.
import { parseIsoAsUtc } from './dateFormat';

const _toDate = (raw) => {
  const d = parseIsoAsUtc(raw);
  return d && !Number.isNaN(d.getTime()) ? d : null;
};

// Short form for cards, e.g. "27 May 2026".
export const formatEditedShort = (raw) => {
  const d = _toDate(raw);
  if (!d) return null;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};

// Long form for preview panels, e.g. "27 May 2026, 9:15 AM".
export const formatEditedLong = (raw) => {
  const d = _toDate(raw);
  if (!d) return null;
  return d.toLocaleString(undefined, {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
};

// Millisecond timestamp used for client-side sorting (0 when missing so such
// rows sink to the bottom on a newest-first sort).
export const editedTimestamp = (raw) => {
  const d = _toDate(raw);
  return d ? d.getTime() : 0;
};
